import React from 'react';
import HeaderTitle from '../../../../components/typography/header-title';
import RedisTagging from '../../../../components/table/redisTaggingTable';

const RedisMetaData = () => {
    return (
        <>
            <HeaderTitle
                title={'Redis Instances Tagging'}
                subtitle={'Manage metadata for Redis instances.'}
            />
            <RedisTagging />
        </>
    );
};

export default RedisMetaData;
